import {
  ExternalUserFieldAccess,
  InputType,
  UnitMagnitude,
} from 'types/geckoFormTypesAndHelpers'
import {
  optionalDateStringWithRegex,
  optionalNumberSchema,
} from 'utils/zodHelpers'

export const installationDateFormField = (
  installation_date: string | undefined,
  isNeededForDerivedLayer: boolean
) => {
  return {
    dataKey: 'installation_date',
    label: 'Installation Date',
    value: installation_date,
    initialValue: new Date(Date.now()).toISOString().split('T')[0],
    unit_magnitude: null,
    validationRule: optionalDateStringWithRegex,
    externalUserAccess: ExternalUserFieldAccess.ReadWrite,
    isNeededForDerivedLayer: isNeededForDerivedLayer,
    inputType: InputType.Date,
  }
}

export const compassOrientationFormField = (
  compass_orientation: number | undefined
) => {
  return {
    dataKey: 'compass_orientation',
    label: 'Compass Orientation',
    value: compass_orientation,
    unit_magnitude: null,
    validationRule: optionalNumberSchema,
    externalUserAccess: ExternalUserFieldAccess.ReadWrite,
    isNeededForDerivedLayer: false,
    inputType: InputType.Number,
  }
}

export const wallThicknessFormField = (wall_thickness: number | undefined) => {
  return {
    dataKey: 'wall_thickness',
    label: 'Nominal Thickness',
    value: wall_thickness,
    unit_magnitude: UnitMagnitude.InchesOrMillimeters,
    validationRule: optionalNumberSchema,
    externalUserAccess: ExternalUserFieldAccess.ReadWrite,
    isNeededForDerivedLayer: true,
    inputType: InputType.Number,
  }
}

export const tminFormField = (tmin: number | undefined) => {
  return {
    dataKey: 'tmin',
    label: 'Tmin',
    value: tmin,
    unit_magnitude: UnitMagnitude.InchesOrMillimeters,
    validationRule: optionalNumberSchema,
    externalUserAccess: ExternalUserFieldAccess.ReadWrite,
    isNeededForDerivedLayer: true,
    inputType: InputType.Number,
  }
}

export const coatingThicknessFormField = (
  coating_thickness: number | undefined
) => {
  return {
    dataKey: 'coating_thickness',
    label: 'Coating Thickness',
    value: coating_thickness,
    unit_magnitude: UnitMagnitude.InchesOrMillimeters,
    validationRule: optionalNumberSchema,
    externalUserAccess: ExternalUserFieldAccess.ReadWrite,
    isNeededForDerivedLayer: false,
    inputType: InputType.Number,
  }
}
